/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation ContactBookBulkCreateMutation($contactBookDirectoryId: ID!, $contactBook: [String!]!) {
  ContactBookBulkCreate(contactBookDirectoryId: $contactBookDirectoryId, contactBook: $contactBook) {
    id
    message
    status
  }
}
`
